module.exports = __webpack_public_path__ + "assets/img/password.efd318f1.svg";